export const KeyboardKeys = {
  ESCAPE: `Escape`,
  ENTER: `Enter`,
  SPACE: `Space`,
  ARROW_DOWN: `ArrowDown`,
  ARROW_UP: `ArrowUp`,
  BACKSPACE: `Backspace`,
};

export const ActivityType = {
  SHOW: `SHOW`,
  HIDE: `HIDE`,
};

export const ListActions = {
  SHOW: `SHOW`,
  HIDE: `HIDE`,
};

export const AddCartTypes = {
  PLUS: `PLUS`,
  MINUS: `MINUS`,
};

export const FormType = {
  electronic: `electronic`,
  PHYSICAL: `PHYSICAL`,
};

export const AnswerType = {
  FAIL: `FAIL`,
  SUCCESS: `SUCCESS`,
};

export const EMAIL_REGEX = /\S+\@\S+\.[a-z]+/i;
export const PHONE_MIN_LENGTH = 10;
export const PIN_REGEX = /^([0-9]{4})$/;

export const CERTIFICATE_TYPE_NAME = `TezisCertificate[type]`;

export const ERROR_CLASS = `form__input--error`;

export const FILL_CLASS = `fill`;

export const Media = {
  MOBILE: window.matchMedia("(max-width: 767px)").matches,
  TABLET: window.matchMedia("(max-width: 1023px)").matches,
};
